import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';
import { administratorLogin } from 'utils/apiCalls';
import Admin from './Admin';

const useStyles = makeStyles(() => ({
  adminLogin: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '20rem',
    height: '100vh',
    margin: '0 auto',
    '& > *': {
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
    },
    '& > button': {
      alignSelf: 'center',
    },
  },
}));

const AdminLogin = () => {
  const classes = useStyles();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [proceedToPage, setProceedToPage] = useState(false);

  const auth = async () => {
    try {
      let resp = await administratorLogin(username, password);
      // console.log('THE RESP', resp);
      if (resp.error) {
        throw resp.error;
      } else if (!resp.isValid) {
        //display error, prevent immediate retry
      } else if (resp.isValid && resp.token) {
        localStorage.clear();
        localStorage.setItem('conference-token', btoa(resp.token));
        setProceedToPage(true);
      } else {
        throw new Error('Server Issue');
      }
    } catch (e) {
      // console.log('Admin Login Error', e);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();
    auth();
  };

  return !proceedToPage ? (
    <form className={classes.adminLogin} onSubmit={onSubmit}>
      <TextField
        required
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        required
        type="password"
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button type="submit" variant="contained" color="primary">
        Login
      </Button>
    </form>
  ) : (
    <Admin />
  );
};

export default AdminLogin;
